export const cloneObject = (data: Record<string, unknown>) => JSON.parse(JSON.stringify(data));
